import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 32 32" {...props}><path d="M19.031 4.281l1.438 1.438L10.188 16l10.281 10.281-1.438 1.438-11-11L7.343 16l.688-.719z" /></svg>);